import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IEventGeneralSettings } from '@sv/interfaces';
import { BehaviorSubject } from 'rxjs';
import { customApp } from 'src/app/_configuration/configuration';

@Injectable({
  providedIn: 'root'
})
export class GeneralSettingsService {
  notLoaded: IEventGeneralSettings = {
    title: '',
    olarkId: '',
    showOlark: false,
    tutorial: false
  };

  generalSettingsListener = new BehaviorSubject<IEventGeneralSettings>(this.notLoaded);

  constructor(private http: HttpClient) {}

  getGeneralSettingsListener() {
    return this.generalSettingsListener.asObservable();
  }

  async setGeneralSettings(generalSettingsId: string | IEventGeneralSettings) {
    if (typeof generalSettingsId === 'string') {
      try {
        const generalSettings = await this.getGeneralSettings(generalSettingsId);
        this.generalSettingsListener.next(generalSettings);
      } catch (error) {
        console.log(error);
        // TODO wie am besten handelen
      }
    } else {
      this.generalSettingsListener.next(generalSettingsId);
    }
  }

  async getGeneralSettings(generalSettingsId: string): Promise<IEventGeneralSettings> {
    const result = await this.http
      .get<{ status: string; data: IEventGeneralSettings; error? }>(
        customApp.url + `/app/event/generalSettings/findById?id=${generalSettingsId}`
      )
      .toPromise();

    if (result.status === 'error') {
      throw result.error;
    } else {
      return result.data;
    }
  }
}
